export default __webpack_public_path__ + "static/media/vfd-inverter-duty.6b84eecc.png";